export default {
	emailColumnHeader: "Email",
	statusColumnHeader: "Status",
	roleColumnHeader: "Role",
};
